import CollapsibleSection from './CollapsibleSection';
import './CollapsibleSection.scss';

export default CollapsibleSection;